import { RootState } from 'core/redux/types';
import { ConsultationStep } from './types';

export function isConsultationOpen(state: RootState): boolean {
    return state.consultation.open;
}

export function getStep(state: RootState): ConsultationStep {
    return state.consultation.step;
}

export function getLocationId(state: RootState): string {
    return state.consultation.locationId;
}

export function getError(state: RootState): string | null {
    return state.consultation.error;
}
